export const BlogUrl ="http://localhost:3000/BlogDetails_page/"